class TransferUserData {
    from: string;
    to: string;
    user: string;
    phone: string;
    email: string;
    position: string;
};

export function initTransferUser() {
    $(document).on("change", ".transfer-user-from", event => {
        let $fromOfficeList = $(event.target) as JQuery<HTMLSelectElement>;
        let $userList = $fromOfficeList.parent().parent().find('.transfer-user-who') as JQuery<HTMLSelectElement>;

        LoadUserList($fromOfficeList.val() as number, $userList);
    });

    $(document).on("change", ".transfer-user-who", event => {
        let $whoList = $(event.target) as JQuery<HTMLSelectElement>;

        let isOfficeAdminSelected = $whoList.children(':selected').data('is-office-admin');

        if (isOfficeAdminSelected) {
            $whoList.addClass('is-office-admin');
        }
        else {
            $whoList.removeClass('is-office-admin');
        }
    });

    $(document).on("click", "#transfer-user-add-row", _ => AddRow(null));

    $(document).on("click", ".transfer-user-delete-row", event => {
        let $clickedButton = $(event.target) as JQuery<HTMLSelectElement>;

        $clickedButton.parents("tr").remove();
    });

    $(document).on("click", "#transfer_user_process_JSON", _ => {
        let json = $("#transfer_user_JSON_input").val() as string;

        let obj = JSON.parse(json) as Array<TransferUserData>;

        $('#transfer-user-table-body').empty();
        obj.forEach(transferUserData => AddRow(transferUserData));
    });

    $(document).on("click", "#transfer_user_process_CSV", _ => {
        let csv = $("#transfer_user_CSV_input").val() as string;
        let separator = $('#transfer_user_CSV_separator').val();
        let delimiter = $('#transfer_user_CSV_delimiter').val();
        let options = {
            separator: separator,
            delimiter: delimiter
        };

        let header = "from,to,user,phone,email,position";
        let firstRow = csv.split('\n')[0];
        if (firstRow != header) {
            csv = header + "\n" + csv;
        }

        let obj = $.csv.toObjects(csv, options) as Array<TransferUserData>;

        $('#transfer-user-table-body').empty();
        obj.forEach(transferUserData => AddRow(transferUserData));
    });
}

// Add a row to the transfer list.
// If the data parameter is null, just an empty row is add (the user clicks the add row button)
// If it is passed, that fills in the rows with the specified info (when loading values from a file)
export function AddRow(data: TransferUserData) {
    var $transferTable = $('#transfer-user-table-body');

    var rowTemplate = <HTMLTemplateElement>document.getElementById('transfer-user-table-row-template');
    var rowToAdd = rowTemplate.content.cloneNode(true) as HTMLTableRowElement;
    let $row = $(rowToAdd);

    if (data) {

        let $from = $row.find('.transfer-user-from') as JQuery<HTMLSelectElement>;
        let $to = $row.find('.transfer-user-to') as JQuery<HTMLSelectElement>;
        let $userList = $row.find('.transfer-user-who') as JQuery<HTMLSelectElement>;
        let $officeEmail = $row.find('.office-email') as JQuery<HTMLSelectElement>;
        let $officePhone = $row.find('.office-phone') as JQuery<HTMLSelectElement>;
        let $position = $row.find('.office-position') as JQuery<HTMLSelectElement>;

        SelectByValue($from, data.from, () => LoadUserList($from.val() as number, $userList, data.user), $control => MarkError($control));
        SelectByValue($to, data.to, null, $control => MarkError($control));

        $officeEmail.val(data.email);
        $officePhone.val(data.phone);
        $position.val(data.position);
    }

    $transferTable.append($row);
}

type SelectByOnSuccessCallback = () => void;
type SelectByOnErrorCallback = ($control: JQuery<HTMLSelectElement>) => void;

// Helper function, takes a HTML select and selects an item based on the displayed value (instead of the internal value)
function SelectByValue($control: JQuery<HTMLSelectElement>, value: string, onSuccess: SelectByOnSuccessCallback = null, onError: SelectByOnErrorCallback = null): void {
    let $option = $control.find(`option:contains("${value}")`);
    for (let i = 0; $option.length > i; i++) {
        var o = $option[i] as HTMLOptionElement;
        if (o.text == value) {
            $option = $($option[i]) as JQuery<HTMLSelectElement>;
            break;
        }
    }

    if ($option.length > 0) {
        $option.prop('selected', true);
        $control.change();

        if ($.isFunction(onSuccess)) {
            onSuccess();
        }
    }
    else {
        if ($.isFunction(onError)) {
            onError($control);
        }
    }
}

function SelectByDataTag($control: JQuery<HTMLSelectElement>, tagName: string, value: string, onSuccess: SelectByOnSuccessCallback = null, onError: SelectByOnErrorCallback = null): void {
    let $option = $control.find(`option[data-${tagName}='${value}']`);

    if ($option.length > 0) {
        $option.prop('selected', true);
        $control.change();

        if ($.isFunction(onSuccess)) {
            onSuccess();
        }
    }
    else {
        if ($.isFunction(onError)) {
            onError($control);
        }
    }
}

// Just marks an element so it is visible to the user, he has to do something
function MarkError($control: JQuery<HTMLElement>) {
    $control.addClass('invalid');
}

// Loads the list of users for the specified office (via AJAX) and puts them in a `HTMLSelectElement` element. Optionally, if a username is specified, selects that user.
export function LoadUserList(officeId: number, $userList: JQuery<HTMLSelectElement>, userName: string = null) {
    $.getJSON(window.ETDR_RD.appConfig["UrlAction.UserListForOffice"], { officeId: officeId }, result => {
        let users = result.Users;

        $userList.empty();

        // Just your usual empty option
        $userList.append(`<option value="">- Kit -</option>`);

        users.forEach(u => {
            $userList.append(`<option value="${u.Id}" data-unique-id="${u.UniqueId}" data-is-office-admin="${u.IsHatosagiAdmin}">${u.DisplayName}</option>`);
        });

        if (userName != null) {
            SelectByDataTag($userList, "unique-id", userName, null, $control => MarkError($control));
        }
    });
}

jQuery(() => {
    initTransferUser();
});
